import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import ImportEmployeesModal from 'modules/employees/components/ImportEmployeesModal'
import { useOnCloseGoToList } from 'modules/employees/hooks/useOnCloseGoList'
import { useEmployeesImporter } from 'modules/employees/lib/employeesImporterContext'
import employees from 'modules/employees/store/collections/employees'

const ImportEmployeesModalPage = () => {
  const onClose = useOnCloseGoToList()
  const importer = useEmployeesImporter()

  const { loading } = useAsyncData(() => employees.fetch({ withCachedFetchParams: true }), [])

  if (loading) {
    return null
  }

  return <ImportEmployeesModal onClose={onClose} importer={importer} employees={employees} />
}

export default ImportEmployeesModalPage
